import React from 'react';
import { X } from 'lucide-react';

// API Configuration
export const API_BASE = "[https://vpcafe.in](https://vpcafe.in)";

export const getMediaUrl = (path) => {
  if (!path) return null;
  if (path.startsWith('http')) return path;
  return `${API_BASE}${path.startsWith('/') ? '' : '/'}${path}`;
};

// API Service Layer
export const api = {
  get: async (endpoint, token) => {
    const res = await fetch(`${API_BASE}${endpoint}`, {
      headers: { 'Authorization': token ? `Bearer ${token}` : '' }
    });
    if (!res.ok) throw await res.json();
    return res.json();
  },
  post: async (endpoint, data, token, isFormData = false) => {
    const headers = { 'Authorization': token ? `Bearer ${token}` : '' };
    if (!isFormData) headers['Content-Type'] = 'application/json';
    const res = await fetch(`${API_BASE}${endpoint}`, {
      method: 'POST',
      headers,
      body: isFormData ? data : JSON.stringify(data)
    });
    if (!res.ok) throw await res.json();
    return res.json();
  },
  put: async (endpoint, data, token, isFormData = false) => {
    const headers = { 'Authorization': token ? `Bearer ${token}` : '' };
    if (!isFormData) headers['Content-Type'] = 'application/json';
    const res = await fetch(`${API_BASE}${endpoint}`, {
      method: 'PUT',
      headers,
      body: isFormData ? data : JSON.stringify(data)
    });
    if (!res.ok) throw await res.json();
    return res.json();
  },
  delete: async (endpoint, token) => {
    const res = await fetch(`${API_BASE}${endpoint}`, {
      method: 'DELETE',
      headers: { 'Authorization': token ? `Bearer ${token}` : '' }
    });
    if (!res.ok) throw await res.json();
    return res.json();
  }
};

// Common Components
export const LoadingSpinner = () => (
  <div className="flex items-center justify-center p-8">
    <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-indigo-600"></div>
  </div>
);

export const Badge = ({ children, status }) => {
  const styles = {
    PENDING: "bg-amber-100 text-amber-700",
    IN_PROCESS: "bg-blue-100 text-blue-700",
    READY: "bg-green-100 text-green-700",
    DELIVERED: "bg-emerald-100 text-emerald-700",
    CANCELLED: "bg-rose-100 text-rose-700",
    PAID: "bg-green-100 text-green-700",
    REFUND_PENDING: "bg-orange-100 text-orange-700"
  };
  return (
    <span className={`px-2 py-1 rounded-full text-xs font-medium ${styles[status] || "bg-gray-100 text-gray-700"}`}>
      {children}
    </span>
  );
};

export const Modal = ({ isOpen, onClose, title, subtitle, children }) => {
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
      <div className="bg-white rounded-[2.5rem] shadow-2xl w-full max-w-2xl overflow-hidden animate-in fade-in zoom-in duration-300">
        <div className="flex justify-between items-start p-8 pb-4">
          <div>
            <h3 className="text-2xl font-black text-[#1a1c2e] leading-tight">{title}</h3>
            {subtitle && <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest mt-1">{subtitle}</p>}
          </div>
          <button onClick={onClose} className="p-2 hover:bg-slate-100 rounded-full transition-colors">
            <X size={24} className="text-slate-400" />
          </button>
        </div>
        <div className="p-8 pt-2 max-h-[85vh] overflow-y-auto no-scrollbar">
          {children}
        </div>
      </div>
    </div>
  );
};